<p>direct-trigger works!</p>
